import script from "./CallBucketPromptModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./CallBucketPromptModal.vue?vue&type=script&lang=ts&setup=true"

import "./CallBucketPromptModal.vue?vue&type=style&index=0&id=28829d57&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28829d57"]])

export default __exports__